import { render, staticRenderFns } from "./adList.vue?vue&type=template&id=bb2570ba"
import script from "./adList.vue?vue&type=script&lang=js"
export * from "./adList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/python/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb2570ba')) {
      api.createRecord('bb2570ba', component.options)
    } else {
      api.reload('bb2570ba', component.options)
    }
    module.hot.accept("./adList.vue?vue&type=template&id=bb2570ba", function () {
      api.rerender('bb2570ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ad/adList.vue"
export default component.exports